import { render, staticRenderFns } from "./EditResultsTeamCard.vue?vue&type=template&id=00f4a444&scoped=true"
import script from "./EditResultsTeamCard.vue?vue&type=script&lang=js"
export * from "./EditResultsTeamCard.vue?vue&type=script&lang=js"
import style0 from "./EditResultsTeamCard.vue?vue&type=style&index=0&id=00f4a444&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f4a444",
  null
  
)

export default component.exports